<template>
  <section class="homepage js-x-scroll-catch">
    <transition-group name="fade">
      <div v-if="posts" key="true" class="c-posts-wrapper js-x-scroll-target-md">
        <posts-cover :content="homepage" />
        <posts-list :posts="posts" @ready="scrollListener()" />
      </div>

      <div v-else key="false">
        <loading-animation />
      </div>

    </transition-group>
  </section>
</template>

<script>
import LoadingAnimation from '@/components/LoadingAnimation'
import PostsCover from '@/components/PostsCover'
import PostsList from '@/components/PostsList'

export default {
  name: 'homepage',
  props: ['posts'],
  components: {
    LoadingAnimation,
    PostsCover,
    PostsList
  },
  computed: {
    homepage () {
      if (this.$store.state.homepage && this.$store.state.homepage.length) {
        return this.$store.state.homepage[0]
      }
    }
  },
  methods: {
    scrollJack (elCatch, elTargetSm, elTargetMd) {
      if (window.innerWidth < 500) return // disable on mobile
      let elTarget = (window.innerWidth >= 1200) ? elTargetMd : elTargetSm // switch scroll element depending on screensize
      elCatch = document.querySelectorAll(elCatch)
      elTarget = document.querySelectorAll(elTarget)

      // mousewheel scroll
      // let mouseWheelEvent = /Gecko\//i.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel'
      let mouseWheelEvent = 'wheel'
      let scroller = function (evt) {
        if (evt.deltaY && elTarget[0]) {
          elTarget[0].scrollLeft += evt.deltaY
        } else {
          elTarget[0].scrollLeft += evt.deltaY
        }
      }
      elCatch[0].addEventListener(mouseWheelEvent, scroller)

      // keyboard scroll
      let arrowKeys = function (evt) {
        // ArrowDown or ArrowRight
        if (evt.keyCode === 40 || evt.keyCode === 39) {
          elTarget[0].scrollLeft += 200

        // ArrowUp or ArrowLeft
        } else if (evt.keyCode === 38 || evt.keyCode === 37) {
          elTarget[0].scrollLeft -= 200
        }
      }
      document.addEventListener('keydown', arrowKeys)
    },
    scrollListener () {
      this.scrollJack('.js-x-scroll-catch', '.js-x-scroll-target-md', '.js-x-scroll-target-lg')
    }
  },
  mounted () {
    this.$nextTick(function () {
      let self = this
      window.addEventListener('resize', self.scrollListener)
      document.body.classList.add('js-no-scroll')
    })
  },
  beforeDestroy () {
    let self = this
    window.removeEventListener('resize', self.scrollListener)
    document.body.classList.remove('js-no-scroll')
  }
}
</script>

<style lang="scss" scoped>
.c-posts-wrapper {
  @media (min-width: $breakpoint-md) {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    align-items: center;
  }

  @media (min-width: $breakpoint-lg) {
    overflow-x: hidden;
    // -webkit-overflow-scrolling: touch;
  }
}
</style>



// WEBPACK FOOTER //
// Homepage.vue?6b95e668